import styled from 'styled-components';
import { breakpoints } from 'styles';

export const CaptchaContainer = styled.div`
  margin-bottom: 24px;
`;

export const CaptchaCode = styled.img`
  width: 100%;
  max-width: 250px;
  height: auto;
`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 0;
  }
`;
